import {WIDTH, HEIGHT, PADDING} from 'components/effects/plane/constants.js';

export const crossedHorizontal = (parameters, xFactor, speed, getDensity) => {
    let min = Math.min(... parameters.map(({x,y, density}) => x + xFactor*speed*10/getDensity(x,y, {density})));
    let max = Math.max(... parameters.map(({x,y, density}) => x + xFactor*speed*10/getDensity(x,y, {density})));
    if (xFactor > 0) {
        return Math.ceil(max) >= WIDTH - PADDING;
    } else {
        return Math.floor(min) <= PADDING;
    }
};

export const crossedVertical = (parameters, yFactor, speed, getDensity) => {
    let min = Math.min(... parameters.map(({x,y, ... coord}) => y + yFactor*speed*10/getDensity(x,y, coord)));
    let max = Math.max(... parameters.map(({x,y, ... coord}) => y + yFactor*speed*10/getDensity(x,y, coord)));
    if (yFactor > 0) {
        return Math.ceil(max) >= HEIGHT - PADDING;
    } else {
        return Math.floor(min) <= PADDING;
    }
};

